// TODO: 这个 request 看能不能封装成 axios 的一样的 API 和 效果（支持拦截等），这样使用体验会更好。
// 如果需要参考，我之前有写过一份。
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { joinParams, parseSearch } from './utils';
import { sendMessage } from './index';
// TODO: 这里的 as 没有必要，反而会减弱代码的理解程度(因为库本身也有 isAndroid 和 isIOS，虽然已废弃)。
// 可直接使用 isAndroidNative 和 isIOSNative
// import { isAndroidNative as isAndroid, isIOSNative as isIOS } from './platform';
import { isAndroidNative, isIOSNative } from './platform';
// 支持手雷统一的request云盘请求
// 注意: 针对云盘批量接口，如about?with_quotas=xxx&with_quotas=xxx, ?ids=xxxx&ids=xxxx这种接口
// ios手雷能正常请求，但安卓需要采用 qs.stringify(params,{ arrayFormat: 'repeat' }) 方式提前拼接到url上才行
const timeout = 1000 * 10;
export function request(url, params = {}, options = {}) {
    return __awaiter(this, void 0, void 0, function* () {
        const method = (options.method || 'GET').toUpperCase(); // 安卓手雷内的method必须为大写
        if (isAndroidNative) {
            if (method === 'GET') {
                // TODO: 在安卓手雷端，如果GET请求某参数为数组形式，需要提前处理好拼接到url上, 如 str = qs.stringify(params, { arrayFormat: 'repeat' });
                // 而ios则正常且不能提前拼接url
                url = joinParams(url, params);
            }
            const res = yield sendMessage({
                platform: 'android',
                name: 'xlAjax',
                params: {
                    url,
                    method,
                    header: options.headers,
                    body: method === 'GET' ? undefined : params,
                    encode: options.encode,
                    type: options.type,
                    raw: options.raw
                },
            }, { callbackTimeout: timeout });
            if (res) {
                if (res.ret === 0) {
                    try {
                        const data = JSON.parse(res.body);
                        return [null, data];
                    }
                    catch (err) {
                        return [null, res.body];
                    }
                }
                else {
                    return [res, null];
                }
            }
            else {
                return [{ error_description: 'unknown' }, null];
            }
        }
        if (isIOSNative) {
            const parseURL = new URL(url);
            const iosRequestParams = {
                method,
                host: parseURL.origin,
                path: parseURL.pathname,
            };
            if (params && Object.keys(params).length > 0) {
                iosRequestParams.params = params;
            }
            if (method !== 'GET') {
                // json 参数请求必须传 1
                iosRequestParams.jsonRequest = 1;
                if (method === 'DELETE') {
                    iosRequestParams.jsonRequest = 0;
                    iosRequestParams.params = parseSearch(parseURL.search);
                }
            }
            if (options.headers) {
                iosRequestParams.headers = options.headers;
            }
            const [err, res] = yield sendMessage({ platform: 'ios', name: 'xlAjax', params: iosRequestParams }, { callbackTimeout: timeout });
            const data_str = (err && err.info) || (res && res.data);
            if (data_str) {
                try {
                    const data = JSON.parse(data_str);
                    if (data.error) {
                        return [data, null];
                    }
                    return [null, data];
                }
                catch (err) {
                    return [data_str, null];
                }
            }
            return [err, res];
        }
    });
}
//# sourceMappingURL=data:application/json;base64,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